import { t } from '../i18n/index.ts';
import { now } from '../lib/clock.ts';
import { agoLabel } from '../lib/format.ts';
import { useStore } from '../state/store.tsx';
import { sourceName } from './ui.tsx';

export function SyncStatus() {
  const { saving, versions, updatedAt } = useStore();
  const head = versions[0];
  const text = saving
    ? t('sync.saving')
    : head
      ? t('sync.status', { source: sourceName(head.source), ago: agoLabel(head.createdAt, now()) })
      : updatedAt
        ? t('sync.status', { source: sourceName('web'), ago: agoLabel(updatedAt, now()) })
        : null;
  if (!text) return null;
  return (
    <span className={`sync-status ${saving ? 'sync-status--saving' : ''}`} role="status">
      <span className="sync-status__dot" aria-hidden="true" />
      {text}
    </span>
  );
}
